export type ErrorMessagesTranslation = {
  unknownError: string;
};

export const errorMessagesTranslation: ErrorMessagesTranslation = {
  unknownError: 'Wystąpił nieznany błąd',
};
